import Page from '@/components/Page/index.ts';
import { getActiveCompetition, competitionWinnersQuery } from '@/lib/api/requests.ts';
import { getQueryClient } from '@/lib/query-client-context.ts';

import type { Route } from './+types/LandingPage';
import { CompetitionsSection } from './_sections/CompetitionsSection.tsx';
import { TimerSection } from './_sections/TimerSection.tsx';
import { TopSection } from './_sections/TopSection.tsx';

export async function loader({ context }: Route.LoaderArgs) {
  const queryClient = getQueryClient(context);
  const competitions = await queryClient.query(competitionWinnersQuery());
  const activeCompetition = await getActiveCompetition(competitions);
  const winners = competitions.find((c) => c.slug === 'january_2026_campaign')?.winners;
  const currentIndex = competitions.findIndex(
    (competition) => competition.slug === 'january_2026_campaign',
  );
  const startIndex = currentIndex + 1;
  const previousCompetitions = competitions.slice(startIndex);
  return { activeCompetition, winners, previousCompetitions };
}

export default function LandingPage({ loaderData }: Route.ComponentProps) {
  return (
    <Page title="Nyttårstrekning">
      <div className="w-full bg-white">
        <TopSection activeCompetition={loaderData.activeCompetition} winners={loaderData.winners} />
        <TimerSection activeCompetition={loaderData.activeCompetition} />
        <CompetitionsSection competitions={loaderData.previousCompetitions} />
      </div>
    </Page>
  );
}
